<ng-template #modalDiv style="top:20%;" let-modal>
  <div class="modal-header" >
    <h4>
      <u>Review: {{ title }}</u>
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div style="padding: 1em;">
      <review-editor [reservation]="reservation" [(review)]="review" [mode]="mode" [kind]="kind" (save)="onSave($event)"></review-editor>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="modal.close()" type="button" role="button" class="btn btn-default btn-lg pull-right">
      Close
    </button>
  </div>
</ng-template>
